import fetch from 'isomorphic-unfetch'

/**
 * Get features from the features endpoint if it exists
 */
export async function getFeatures(baseUrl) {
  try {
    const features = await fetch(
      `http://${baseUrl}/feature-flags`
    ).then((response) => response.json())

    return features
  } catch {
    return {}
  }
}
